import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { DepartmentModalAdd } from '../utilites/Forms';
import { HookForm } from '../../validation/HForm';
import { Message } from '../utilites';
import { addCashbox, resetHandbook } from '../../redux/actions/handbookAction';
import DepartmentAddLoader from './Loader/DepartmentAddLoader';
import createCashBoxScheme from "../../validation/scheme/cashBoxScheme";

const defaultValues = {
  name: '',
  phone: '',
  city: '',
  street: '',
  house: '',
  building: '',
  office: '',
  additionalInfo: '',
  leaderId: {
      value: 0,
      label: ''
  },
  chiefAccountantId: {
      value: 0,
      label: ''
  },
  accountantId: {
      value: 0,
      label: ''
  },
  seniorCommodityExpertId: {
      value: 0,
      label: ''
  },
  goodsSpecialistsIds: []
};

const DepartmentAdd = () => {
  const { addDepartment, addDepartmentLoading, addDepartmentError, employeesError } = useSelector(
    ({ handbook }) => handbook,
  );
  const { accessFeatures } = useSelector(({ user }) => user);
  const history = useHistory();
  const dispatch = useDispatch();

  const[formState, setFormState] = useState(defaultValues)

  useEffect(() => {
    if (addDepartment) {
      history.push('/handbooks/departments');

      return () => dispatch(resetHandbook());
    }
  }, [addDepartment, history, dispatch]);

  const onSubmit = (entity) => {
    setFormState(entity)
    const data = {
      ...entity,
      leaderId: entity.leaderId.value + '',
      chiefAccountantId: entity.chiefAccountantId.value + '',
      accountantId: entity.accountantId.value + '',
      seniorCommodityExpertId: entity.seniorCommodityExpertId.value + '',
      goodsSpecialistsIds: entity.goodsSpecialistsIds.map(({ value }) => value),
      active: true,
    };
    if (accessFeatures['cashbox.mobile']) {
      data.mobilePhone = entity.mobilePhone && entity.mobilePhone !== '+375 __ ___ __ __' ? entity.mobilePhone : ''
    }
    dispatch(addCashbox(data));
  };

  const handleGoBack = () => {
    dispatch(resetHandbook())
    history.goBack();
  }

  return (
    <>
      {(addDepartmentError || employeesError) && (
        <Message type="error" text={addDepartmentError || employeesError} />
      )}
      {addDepartmentLoading ? (
        <DepartmentAddLoader />
      ) : (
        !addDepartment && (
          <HookForm onSubmit={onSubmit} 
                    validationSchema={createCashBoxScheme(accessFeatures["cashboxNameTypeOne"], accessFeatures["cashbox.mobile"], accessFeatures["cash_box.main.enable"])}
                    submitOnEnterPress = {true}
                    defaultValues={formState}>
            <div className="content-inner-data-container">
              <fieldset>
                <div className="content-section-title">
                  <div className="content-section-title-actionitems">
                    <h2>Создание подразделения</h2>
                  </div>
                </div>
              </fieldset>
              <DepartmentModalAdd h="true" />
              <div className="content-inner-data-container-footer">
                <button className="button" type="submit">
                  Добавить
                </button>
                <button className="button-light" type="button" onClick={handleGoBack}>
                  Отменить
                </button>
              </div>
            </div>
          </HookForm>
        )
      )}
    </>
  );
};

export default DepartmentAdd;
